<div class="full-height layout-column overflow-x-auto-only">

  <app-dashboard-services-table class="flex"
                                [services]="services" (fetchNextEvent)="getNextBatch()"
                                [isLeanData]="isLeanData"
                                (onViewServiceRelatedTasks)="onViewServiceRelatedTasks.emit($event)">
  </app-dashboard-services-table>

  <loader [isDisplayLoader]="isLoadingData"></loader>

</div>


